var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Modal } from '@core';
import { twJoin } from 'tailwind-merge';
export var DeleteModal = function (_a) {
    var _b;
    var onCancel = _a.onCancel, onConfirm = _a.onConfirm, children = _a.children, props = __rest(_a, ["onCancel", "onConfirm", "children"]);
    return (_jsx(Modal, __assign({ Footer: function () { return (_jsxs("div", __assign({ className: "flex justify-end gap-7 px-4 py-3" }, { children: [_jsx(Button, __assign({ onClick: onConfirm, className: "flex w-fit flex-row items-center px-4 py-1.5" }, { children: _jsx("p", __assign({ className: "font-sans text-sm font-semibold" }, { children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C" })) })), _jsx(Button, __assign({ onClick: onCancel, className: "flex w-fit flex-row items-center px-4 py-1.5" }, { children: _jsx("p", __assign({ className: "font-sans text-sm font-semibold" }, { children: "\u041E\u0442\u043C\u0435\u043D\u0430" })) }))] }))); }, contentClassName: twJoin('text-center', (_b = props.contentClassName) !== null && _b !== void 0 ? _b : '') }, props, { children: children })));
};
